<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Organise Modules
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <ul class="course-tree">
        <draggable-tree
          :data="treeData"
          draggable
          @drag="onDrag"
          @drop="treeChange"
        >
          <li slot-scope="{ data }">
            <span :class="data.class" :key="data.id">{{ data.text }}</span>
          </li>
        </draggable-tree>
      </ul>
    </v-container>
    <v-footer absolute height="100">
      <v-flex px-4 py-4 text-xs-right>
        <v-btn v-if="!loading" color="primary" @click="closePanel">
          Cancel
        </v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" @click="saveOrder">Save</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import channelAPI from "@/api/channel.js";
import { DraggableTree } from "vue-draggable-nested-tree";
import * as th from "tree-helper";
import { EventBus } from "@/event-bus.js";

export default {
  name: "ChannelDetails",
  components: {
    DraggableTree
  },
  props: {
    id: {
      type: String,
      default: null
    },
    params: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      maxLevel: 1,
      channel: {},

      loading: false,
      valid: true,
      messages: [],
      treeData: [],
      itemClass: "",
      kids: [],
      treeJson: {},
      tempData: []
    };
  },
  mounted() {
    this.getChannel(this.id);
    // getCourses() removed: it fetched the ENTIRE course library through the
    // heavy /courses endpoint (~28s for a large customer) into this.courses,
    // which nothing in this component ever read - pure dead weight on every
    // playlist-content open.
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    onDrag(node) {
      const rootNode = node._vm.store.rootData;
      this.$set(rootNode, "droppable", false);

      th.depthFirstSearch(this.treeData, childNode => {
        if (childNode === node) {
          return "skip children";
        }
        if (node.type === "module") {
          this.$set(childNode, "droppable", childNode.type === "level");
        } else {
          this.$set(childNode, "droppable", false);
        }
      });
    },
    tempArray() {
      let tempArray = this.channel.organised.data.map(x => {
        return {
          id: x.course_id,
          level: x.level,
          sort_order: x.sort_order
        };
      });
      this.tempData = tempArray;
    },
    organiseTree() {
      var i;
      var nodeData;

      nodeData = {
        text: "Unorganised Modules",
        draggable: false,
        class: "unorganised",
        level: 0,
        type: "level"
      };

      this.treeData.push(nodeData);

      for (i = 0; i < this.channel.levels; i++) {
        let kids = this.channel.organised.data
          .filter(x => {
            if (x.level === i + 1) {
              return true;
            }
            return false;
          })
          .map(x => {
            return {
              text: x.course_name,
              id: x.course_id,
              draggable: true,
              droppable: false,
              class: "course",
              type: "module"
            };
          });

        nodeData = {
          text: "Level " + (i + 1),
          draggable: false,
          class: "level",
          children: kids,
          level: i + 1,
          type: "level"
        };

        this.treeData.push(nodeData);
      }
    },
    getChannel(id) {
      channelAPI.getChannel(id, "?include=organised").then(response => {
        this.channel = response.data.data;
        this.organiseTree();
        this.tempArray();
      });
    },
    treeChange(node) {
      var objIndex = this.tempData.findIndex(obj => obj.id == node.id);
      this.tempData[objIndex].level = node.parent.level;
      this.tempData[objIndex].sort_order = node.parent.children.indexOf(node);
      // MAP other indexes
    },
    saveOrder() {
      this.loading = true;
      channelAPI
        .saveCourseOrder(this.id, this.tempData)
        .then(() => {
          this.closePanel();
          EventBus.$emit("CHANNELS_UPDATED", this.params);
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
        });
    }
  }
};
</script>
